/** View library */
import React from "react";
import Autobind from "autobind-decorator";
import { inject, observer } from "mobx-react";
import {
  Link,
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";
import { LoginPage, SarcopeniaDemoDashboard } from "pages/demo-dashboard/";
import Constant from "constants/index";
import Config from "config"; // 프로그램 환경설정 모듈

@inject("authStore")
@observer
@Autobind
class AppDispatcherPage extends React.Component {
  renderApp(connectApp) {
    if (connectApp === "sarcopenia-ai") {
      return (
        <Route
          exact
          path={`${Constant.RootPrefix}/`}
          component={SarcopeniaDemoDashboard}
        />
      );
      //return <Route exact path="/" component={SarcopeniaDemoDashboard} />;
    } else if (connectApp === "webviewer") {
      return (
        <Route
          exact
          path={`${Constant.RootPrefix}/`}
          render={(window.location.href = Config.servers.Webviewer)}
        />
      );
    }

    return <Redirect to={{ pathname: `${Constant.RootPrefix}/login` }} />;
  }

  render() {
    const { authStore } = this.props;
    const isSignedIn = authStore.getIsSignedIn();
    const connectApp = authStore.getConnectApp();
    return (
      <React.Fragment>
        {isSignedIn === false ? (
          <Redirect to={{ pathname: `${Constant.RootPrefix}/login` }} />
        ) : (
          this.renderApp(connectApp)
        )}
      </React.Fragment>
    );
  }
}

export default AppDispatcherPage;
